'use strict';

const {degToRad} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('sub-squares', function () {
    let shapes = [];

    let sideLength = this.width - this.pad * 2;

    let bigSquare = new Shape(4, sideLength, new Point(this.pad + sideLength, this.pad + sideLength));
    bigSquare.setFractalProportion(0.5);
    shapes.push(bigSquare);
    const subShapes = bigSquare.getProportionalSubShapes();
    shapes.concat(subShapes).forEach(shape => shape.draw(this.ctx));
});


